module.exports = __webpack_public_path__ + "img/1.96a248f2.jpg";